import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/common/react/CommonStyles';
import { cssClass } from '~src/style';
import { L10n } from '~src/ts/L10n/L10n';

import { AccelerationTasks } from '../resources/AccelerationTasks';

export function AcceleratedViewLimitInfo() {
  const [numOfEnabledSheets, setNumOfEnabledSheets] = React.useState(undefined);
  const [acceleratedViewLimit, setAcceleratedViewLimit] = React.useState(undefined);
  const [acceleratedViewLimitEnabled, setAcceleratedViewLimitEnabled] = React.useState(undefined);

  React.useEffect(
    () => {
      let didUnmount = false;

      AccelerationTasks.findAcceleratedViewLimitInfo()
        .then(response => {
          if (!didUnmount) {
            if (response.errors === undefined) {
              setNumOfEnabledSheets(response.numOfEnabledSheets);
              setAcceleratedViewLimit(response.viewsLimitPerSiteForAcceleration);
              setAcceleratedViewLimitEnabled(response.viewsLimitPerSiteForAccelerationEnabled);
            }
          }
        });

      return () => {
        didUnmount = true;
      };
    },
    []
  );

  return (
    numOfEnabledSheets !== undefined && acceleratedViewLimit !== undefined &&
    acceleratedViewLimitEnabled !== undefined &&
    <span className={AcceleratedViewsLimitInfo}>
      {acceleratedViewLimitEnabled? Messages.acceleratedView() + ': ' + L10n.localizedCount(numOfEnabledSheets) + '/' + L10n.localizedCount(acceleratedViewLimit)
      : Messages.acceleratedView() + ': ' + L10n.localizedCount(numOfEnabledSheets)}
    </span>
  );
}

const cssPrefix = 'AcceleratedViewLimitInfo';
const AcceleratedViewsLimitInfo = cssClass(cssPrefix, 'item', {
  minWidth: 0, // 0 is the default
  color: CommonStyles.Colors.Grey102,
  fontSize: '14px',
});
